"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePlaceHolderFieldFromWidget = exports.alignLastGameWidget = exports.HomePageWidgetsCategory = exports.ELockReason = exports.HomeWidgetType = exports.SuperAppABBucket = exports.ctaValue = exports.ctaType = void 0;
const lodash = require("lodash");
var ctaType;
(function (ctaType) {
    ctaType["ACTION"] = "ACTION";
    ctaType["DEEP_LINK"] = "DEEP_LINK";
})(ctaType = exports.ctaType || (exports.ctaType = {}));
var ctaValue;
(function (ctaValue) {
    ctaValue["VERIFY_LOCATION"] = "VERIFY_LOCATION";
})(ctaValue = exports.ctaValue || (exports.ctaValue = {}));
var SuperAppABBucket;
(function (SuperAppABBucket) {
    SuperAppABBucket["CONTROL"] = "control";
    SuperAppABBucket["TURBO_ON_TURBO_FIRST"] = "turboOnTurboFirst";
    SuperAppABBucket["TURBO_ON_NINJA_FIRST"] = "turboOnNinjaFirst";
    SuperAppABBucket["LUDO_ONLY_IF_NOT_PLAYED_ANY_GAME"] = "ludoOnlyIfNotPlayedAnyGame";
    SuperAppABBucket["LUDO_ONLY_OTHERS_LOCKED_IF_NOT_PLAYED_ANY_GAME"] = "ludoOnlyOthersLockedTillNGameplays";
})(SuperAppABBucket = exports.SuperAppABBucket || (exports.SuperAppABBucket = {}));
var HomeWidgetType;
(function (HomeWidgetType) {
    HomeWidgetType["CAROUSEL"] = "carousel";
    HomeWidgetType["HERO"] = "hero";
    HomeWidgetType["GRID"] = "grid";
    HomeWidgetType["IMAGE"] = "image";
})(HomeWidgetType = exports.HomeWidgetType || (exports.HomeWidgetType = {}));
var ELockReason;
(function (ELockReason) {
    ELockReason["UNDER_MAINTENANCE"] = "UNDER_MAINTENANCE";
    ELockReason["BANNED_STATE"] = "BANNED_STATE";
    ELockReason["NEW_USER"] = "NEW_USER";
})(ELockReason = exports.ELockReason || (exports.ELockReason = {}));
var HomePageWidgetsCategory;
(function (HomePageWidgetsCategory) {
    HomePageWidgetsCategory["MTT"] = "MTT";
    HomePageWidgetsCategory["REFERRAL"] = "REFERRAL";
    HomePageWidgetsCategory["GAMES"] = "GAMES";
    HomePageWidgetsCategory["BANNER"] = "BANNERS";
    HomePageWidgetsCategory["SPACE"] = "SPACE";
    HomePageWidgetsCategory["ALL_GAMES"] = "ALL_GAMES";
    HomePageWidgetsCategory["APP_UPDATE"] = "APP_UPDATE";
})(HomePageWidgetsCategory = exports.HomePageWidgetsCategory || (exports.HomePageWidgetsCategory = {}));
const alignLastGameWidget = (widgets) => {
    let gameWidgetWith2Cols = 0;
    let lastGamesIndex = -1;
    for (let idx = 0; idx < widgets.length; ++idx) {
        if (widgets[idx].placeholderFor === HomePageWidgetsCategory.GAMES && widgets[idx].numOfCols == '2') {
            ++gameWidgetWith2Cols;
            lastGamesIndex = idx;
        }
    }
    if (gameWidgetWith2Cols % 2 != 0) {
        widgets[lastGamesIndex].numOfCols = '1';
    }
};
exports.alignLastGameWidget = alignLastGameWidget;
const removePlaceHolderFieldFromWidget = (widgets) => {
    for (let widget of widgets) {
        if (!lodash.isNil(widget.placeholderFor)) {
            delete widget.placeholderFor;
        }
    }
};
exports.removePlaceHolderFieldFromWidget = removePlaceHolderFieldFromWidget;
//# sourceMappingURL=homePage.model.js.map